const actions = {
  FETCH_NOTIFICATIONS_REQUEST: "FETCH_NOTIFICATIONS_REQUEST",

  fetchNotifications: (reload) => (dispatch) => {
    dispatch({
      type: actions.FETCH_NOTIFICATIONS_REQUEST,

      payload: reload,
    });
  },
};

export default actions;
